module.exports = "/images/PB.png?fce671e3cb8e9e93d6d9792fe51ec2cf";